import type { ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from './cn';

/**
 * Small tokenised label (PRO-0260). Used for the compose stepper step state
 * (`current | done | upcoming`). Presentation only — semantics are carried by the
 * surrounding list, not the badge colour.
 */
const badgeVariants = cva('inline-flex items-center gap-1 rounded-sm px-2 py-0.5 text-sm font-medium', {
  variants: {
    state: {
      current: 'bg-primary text-primary-foreground',
      done: 'bg-success-bg text-success-foreground',
      upcoming: 'bg-muted text-text-secondary',
    },
  },
  defaultVariants: { state: 'upcoming' },
});

export type BadgeProps = { className?: string; children: ReactNode } & VariantProps<typeof badgeVariants>;

export function Badge({ state, className, children }: BadgeProps) {
  return <span className={cn(badgeVariants({ state }), className)}>{children}</span>;
}
